
import { ArrowCircleRightSharp } from '@mui/icons-material';
import parse from 'html-react-parser';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useParams, useRouteMatch } from "react-router-dom";
import Scroll from 'react-scroll';
import ConnUrls from '../../Connections/ConnectURL';
import { CurrentPContext, MasterContext, MobiOrNotContext, OrderContext } from '../../ContextApi/context';
import ScrollingSaver from '../../DTechComp/ScrollingSaver';
import utilsLandingPage from '../../_Utils/utilsLandingPage';
import myFunctions from '../../myFunctions';
import { Helmet } from 'react-helmet';
import AppsLinksePage from './LandinPages/AppsLinksePage';
import PopUpTheComp from '../../DTechComp/PopUpTheComp';
import WaitImgOverlay from '../../DTechComp/WaitImgOverlay';

var scroller = Scroll.scroller;
var scroll = Scroll.animateScroll;

const LandingPage = (props) => {

  const currentUrl = window.location.href;
  const urlObject = new URL(currentUrl);
  const domain = urlObject.origin;

  const [master, setMaster] = useContext(MasterContext);

  const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
  const [currentPage, setCurrentPage] = useContext(CurrentPContext);
  const [loading, setLoading] = useState(true);
  const [waitImgItm, setWaitImgItm] = useState({});
  const [thePopUp, setThePopUp] = useState("");
  const [landingDataReady, setLandingDataReady] = useState(false);

  let { path, url } = useRouteMatch();

  const history = useHistory();
  const params = useParams();

  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  }

  useEffect(() => {

    //currentPage עדיין של העמוד הקודם, ולכן חישוב ממנו הציג לרגע תמונה זרה (בד"כ של המאסטר).
    //התמונה נקבעת כשנתוני העמוד מגיעים; עד אז נשאר מסך לבן.
    if (master?.imgWaitingActive === false) setWaitImgItm({ active: false });

    props.shoTopStrp(false)
    getLandingPage();
    setLoading(false);

  }, [])


  const getLandingPage = async () => {
    // let pName = props.pageName || window.document.href.substring(window.document.href.lastIndexOf('/') + 1)
    let theSingle = await utilsLandingPage.getPageByName(props.pageName);

    setWaitImgItm(myFunctions.setTheImgWait(theSingle, master, mobiOrNot));
    setCurrentPage({ ...theSingle, pageTYp: "" });
    setThePopUp(
      <PopUpTheComp
        // closePop={() => { props.stickyShow(true); setThePopUp() }}
        closePop={null}
        cssStyl={"landingPagepopUp onTopOfAll"}
        BgSet={`url(${ConnUrls.media(theSingle.mainImage)})`}
        theInsideComp={
          <AppsLinksePage theSingle={theSingle}
            BgSet={`url("${ConnUrls.media(theSingle.mainImage)}")`}
            closeMe={() => setThePopUp()} />}
        Title={[""]}
      />
    )
    setLandingDataReady(true);
  }
  const goToBack = () => {
    sessionStorage.setItem("LandingPage", "");
    history.goBack();

  }


  return (
    <div className="LandingPage">
      <WaitImgOverlay item={waitImgItm} ready={landingDataReady} />

      {!landingDataReady ? "" :
        <>
          {(mobiOrNot) ?
            <>
              <div className={"headOnFixC SecondFont bold big"}>
                <div className={`backSdOnlyBtn`}>
                  <ArrowCircleRightSharp onClick={() => goToBack()} />
                </div>


              </div>
              <div className={`LandingPagePad`}>
              </div>
            </>
            :
            ""
          }
          <div>
            {props.typeOfLandPage}
          </div>
        </>

      }

      <Helmet
        meta={[
          {
            property: "og:url", content: `${ConnUrls.siteDomainNam}/${encodeURIComponent(currentPage.inLinkToPage)}`
          }
        ]}>
        <link rel="canonical" href={`${ConnUrls.siteDomainNam}/${encodeURIComponent(currentPage.inLinkToPage)}`} />
      </Helmet>


      {thePopUp}



    </div >
  );
}

export default LandingPage;
